/**
 * @prettier
 */
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import ReportTable from '../components/ReportTable'
import { fetchReportList } from '../actions/fundingfeeActions'
import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'

const ReportContainer = ({ fundingFee, fetchReportList }) => {
  const {
    params: { action }
  } = useRouteMatch('/lgyhub/funding-fee/refunds/report/:action')

  useEffect(() => {
    fetchReportList(action?.toUpperCase())
  }, [fetchReportList, action])

  return (
    <div className='lgy-funding-fee-refund-reports'>
      {(fundingFee.posting || fundingFee.fetching || !fundingFee.reports) && <LgyLoadingIcon />}
      {fundingFee.reports && <ReportTable reports={fundingFee.reports} />}
    </div>
  )
}

const mapStateToProps = state => ({ fundingFee: state.fundingFee })

export default connect(mapStateToProps, { fetchReportList })(ReportContainer)
